export default "__VITE_ASSET__DqgprrnM__"